
export const AppFooter = () => {
    return (
        <footer className="app_footer" >
            &copy;&nbsp;2023&nbsp;
            <a href="https://twitter.com/kdnakt">kdnakt</a>
        </footer>
    )
}